import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';
import { toast } from 'react-toastify';
import List from '../../components/Crud/List';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';
import { Role } from '../../components/User/UserForm';
import CustomButton from '../../components/CustomButton/CustomButton';

type UserModel = {
  id: number;
  role: string;
  name: string;
  email: string;
};

export default function UsersIndex() {
  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState([] as UserModel[]);
  const [roles, setRoles] = useState<Record<string, string>>({});

  const {
    user: { organization },
  } = useAuth();

  async function getUsers() {
    if (organization) {
      setIsLoading(true);
      const response = await api.get(
        `admin/organizations/${organization.id}/users`
      );
      setUsers(response.data.data);
      setIsLoading(false);
    }
  }

  async function getRoles() {
    if (organization) {
      const { data } = await api.get(
        `admin/organizations/${organization.id}/users/available-roles`
      );

      setRoles(
        data.data.reduce((acc: any, role: Role) => {
          acc[role.value] = role.label;
          return acc;
        }, {})
      );
    }
  }

  const removeUser = useCallback(
    async (user: UserModel) => {
      try {
        if (
          // eslint-disable-next-line no-restricted-globals
          confirm(
            `Você tem certeza que deseja remover o usuário"? Essa ação não poderá ser desfeita.`
          )
        ) {
          await api.delete(
            `admin/organizations/${organization.id}/users/${user.id}`
          );
          getUsers();
          toast.success(`O usuário foi removido.`);
        }
      } catch (e) {
        toast.error(
          `Houve um problema ao tentar remover o usuário. Tente novamente.`
        );
      }
    },
    [organization.id, getUsers, toast]
  );

  useEffect(() => {
    getUsers();
    getRoles();
  }, [organization]);

  return (
    <List isLoading={isLoading} title='Colaboradores' newItemUrl='new'>
      <table className='table table-hover'>
        <thead>
          <tr>
            <th scope='col'>#</th>
            <th scope='col'>Perfil</th>
            <th scope='col'>Nome</th>
            <th scope='col'>E-mail</th>
            <th scope='col'>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {users.map((i) => {
            return (
              <tr key={i.id}>
                <th scope='row'>{i.id}</th>
                <td>{roles[i.role] ?? i.role}</td>
                <td>
                  <Link to={`${i.id}/edit`}>{i.name}</Link>
                </td>
                <td>{i.email}</td>
                <td>
                  <CustomButton
                    className='btn btn-sm btn-danger'
                    type='button'
                    handleClick={() => removeUser(i)}
                  >
                    <FaTimes />
                  </CustomButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </List>
  );
}
